import React from "react";
import styled from "styled-components";
import { TextFont, Colors, Text } from "../../config";
import TotalWrapper from "./TotalWrapper";

const FareSummaryContainer = (props) => {
  return (
    <FareSummaryWrapper width={props.width ? props.width : "18rem"}>
      <FareSummaryHeader>
        <TextFont
          fontColor={Colors.sharkApprox}
          fontSize="1.125rem"
          fontWeight="700"
        >
          {Text.fareSummary}
        </TextFont>
      </FareSummaryHeader>
      <FareSummaryBody>{props.children}</FareSummaryBody>
      <TotalWrapper total="4,097" />
    </FareSummaryWrapper>
  );
};

export default FareSummaryContainer;

export const FareSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width}; 
`;
export const FareSummaryHeader = styled.div`
  background: ${Colors.brandFive};
  padding: 0.75rem 1.25rem 0.75rem 1.25rem;
  border-radius: 0.5rem 0.5rem 0 0;
`;
export const FareSummaryBody = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.white};
  padding: 0 1.375rem;
`;
